import { atom, useAtomValue, useSetAtom, getDefaultStore } from 'jotai';

export const metasiteError = atom<boolean>(false);

export const useMetasiteError = () => {
  return useAtomValue(metasiteError);
};

export const useSetMetasiteError = () => {
  return useSetAtom(metasiteError);
};

export const setMetasiteError = (value: boolean) => {
  getDefaultStore().set(metasiteError, value);
};

export const resetMetasiteError = () => {
  getDefaultStore().set(metasiteError, false);
};
